import React, { useState, useContext, useEffect } from 'react';
import { Button, ButtonTitle } from '../../styles/commonStyles';

import { LayoutContext } from '../../context/layoutContext';

const ButtonTabs = props => {
  const { matchese } = useContext(LayoutContext);
  const { tabList, type, value = 0, rtValue, title } = props;

  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setTabValue(value);
  }, [value]);

  const changeTabValue = e => {
    let value = Number(e.target.value);

    rtValue(value);
    setTabValue(value);
  };

  // type === main 버튼색 변경
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 1%', flexDirection: matchese ? 'column' : 'row' }}>
        <ButtonTitle>
          <span className='title'> {title ? title : ''}</span>
        </ButtonTitle>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          {tabList.map((list, idx) => {
            return (
              <Button key={`tab_${idx}`} value={`${idx}`} onClick={changeTabValue} Cancel={tabValue === idx ? false : true} type={type}>
                {list}
              </Button>
            );
          })}
        </div>
        <div style={{ fontSize: '23px', visibility: 'hidden', display: matchese ? 'none' : 'block' }}>{title ? title : ''}</div>
      </div>
    </>
  );
};

export default ButtonTabs;
